import { Injectable } from '@angular/core';
import { GraphqlService } from '@app/core/services/graphql.service';
import { pdfBulkExportMutation } from '@app/pcs/data/bulk-export.mutations';
import { DossierBulkExportContext } from '@app/pcs/models/bulk-export';

@Injectable()
export class BulkExportDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  exportPdfBulk(context: DossierBulkExportContext) {
    return this.graphqlService.mutation(pdfBulkExportMutation, {context});
  }
}
